import { httpClient } from '@shared/api'
import type { Token, TokenDTO } from '../model/types'
import { mapCreateTokenArgsToDTO, mapTokenFromDTO } from './mappers'
import type { CreateTokenArgs, DeleteTokenArgs } from './types'

export const getTokens = async (): Promise<Token[]> => {
    const { data: result } = await httpClient.get<TokenDTO[]>('/ads/tokens')
    return result.map(mapTokenFromDTO)
}

export const createToken = async (data: CreateTokenArgs): Promise<Token> => {
    const { data: result } = await httpClient.post<TokenDTO>('/ads/tokens', mapCreateTokenArgsToDTO(data))
    return mapTokenFromDTO(result)
}

export const deleteToken = async ({ id }: DeleteTokenArgs): Promise<void> => {
    await httpClient.delete<void>(`/ads/tokens/${id}`)
}
